import { Student } from "src/app/shared/models/student.model";

export interface SuperstarSelectCardData {
    id: string
    name: string;
    icon: string;
    isSelected: boolean;
    placeholder: string;
}

export interface SuperstarSVGCard extends Student {
    svgIcon: string;
    gradeRange : string;
}

export interface SuperstarCardPrint extends Student {
      svgIcon: string;
    studentId: string;
  studentName: string;
  teacherName: string;
      message: string;
}

export const gradeCards: { grade: string, text: string, cards: SuperstarSelectCardData[] }[] = [{
    grade: "K-2", text: "K-2", cards: [
      { id: '1-05', name: 'superstarbadge-lvl_1-05', icon: "superstarbadge-lvl_1-05.svg", isSelected: false, placeholder: "Sunshine Spirit Award" },
      { id: '1-06', name: 'superstarbadge-lvl_1-06', icon: "superstarbadge-lvl_1-06.svg", isSelected: false, placeholder: "Dream Believe Achieve Award"},
      { id: '1-07', name: 'superstarbadge-lvl_1-07', icon: "superstarbadge-lvl_1-07.svg", isSelected: false, placeholder: "Pathfinder Award"},
      { id: '1-08', name: 'superstarbadge-lvl_1-08', icon: "superstarbadge-lvl_1-08.svg", isSelected: false, placeholder: "On Wings of Vibrant Colors Award"},
      { id: '1-01', name: 'superstarbadge-lvl_1-01', icon: "superstarbadge-lvl_1-01.svg", isSelected: false, placeholder: "Working Like a Tiger Award" },
      { id: '1-02', name: 'superstarbadge-lvl_1-02', icon: "superstarbadge-lvl_1-02.svg", isSelected: false, placeholder: "Tippy Top of the Mountain Award"},
      { id: '1-03', name: 'superstarbadge-lvl_1-03', icon: "superstarbadge-lvl_1-03.svg", isSelected: false, placeholder: "Crowning Achievement Award"},
      { id: '1-04', name: 'superstarbadge-lvl_1-04', icon: "superstarbadge-lvl_1-04.svg", isSelected: false, placeholder: "Buzzy Busy Bee Award"}
    ]
  },
  {
    grade: "3-5", text: "3-5", cards: [
      { id: '2-05', name: 'superstarbadge-lvl_2-05', icon: "superstarbadge-lvl_2-05.svg", isSelected: false, placeholder: "Fly like an Eagle Award" },
      { id: '2-06', name: 'superstarbadge-lvl_2-06', icon: "superstarbadge-lvl_2-06.svg", isSelected: false, placeholder: "You are a Firecracker Award" },
      { id: '2-07', name: 'superstarbadge-lvl_2-07', icon: "superstarbadge-lvl_2-07.svg", isSelected: false, placeholder: "Get Set Cadet Award" },
      { id: '2-08', name: 'superstarbadge-lvl_2-08', icon: "superstarbadge-lvl_2-08.svg", isSelected: false, placeholder: "High Five Award" },
      { id: '2-01', name: 'superstarbadge-lvl_2-01', icon: "superstarbadge-lvl_2-01.svg", isSelected: false, placeholder: "Rocket to the Stars Award" },
      { id: '2-02', name: 'superstarbadge-lvl_2-02', icon: "superstarbadge-lvl_2-02.svg", isSelected: false, placeholder: "Atomic Activity Award" },
      { id: '2-03', name: 'superstarbadge-lvl_2-03', icon: "superstarbadge-lvl_2-03.svg", isSelected: false, placeholder: "Blooming Scholar Award" },
      { id: '2-04', name: 'superstarbadge-lvl_2-04', icon: "superstarbadge-lvl_2-04.svg", isSelected: false, placeholder: "Awesome Sauce Award" }
    ]
  },
  {
    grade: "6-12", text: "6-12", cards: [
      { id: '3-06', name: 'superstarbadge-lvl_3-06', icon: "superstarbadge-lvl_3-06.svg", isSelected: false, placeholder: "Boundless Curiosity Illuminates the Path to Wisdom Award" },
      { id: '3-07', name: 'superstarbadge-lvl_3-07', icon: "superstarbadge-lvl_3-07.svg", isSelected: false, placeholder: "We Salute Your Quest Award" },
      { id: '3-01', name: 'superstarbadge-lvl_3-01', icon: "superstarbadge-lvl_3-01.svg", isSelected: false, placeholder: "Illustrious Efforts in Academia Award 1" },
      { id: '3-02', name: 'superstarbadge-lvl_3-02', icon: "superstarbadge-lvl_3-02.svg", isSelected: false, placeholder: "Illustrious Efforts in Academia Award 2" },
      { id: '3-03', name: 'superstarbadge-lvl_3-03', icon: "superstarbadge-lvl_3-03.svg", isSelected: false, placeholder: "Exemplary Dedication to Intellectual Pursuits Award" },
      { id: '3-04', name: 'superstarbadge-lvl_3-04', icon: "superstarbadge-lvl_3-04.svg", isSelected: false, placeholder: "Realms of Knowledge Award"},
      { id: '3-05', name: 'superstarbadge-lvl_3-05', icon: "superstarbadge-lvl_3-05.svg", isSelected: false, placeholder: "Remarkable Success in Scholastic Endeavors Award" }
    ]
  }];
